import filtros from './filtros';
import projetos from './projetos';

export default {
  namespaced: true,
  modules: {
    filtros,
    projetos,
  },
};
